import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography } from '@mui/material'

const AboutIQAC = () => {
  const navigate = useNavigate()
  const About_IQAC_data = {
    ABOUT: {
      title: 'ABOUT IQAC',
      description:
        'An Internal Quality Assurance Cell (IQAC) has been established during the academic year 2019. It aims to develop a system for conscious, consistent and catalytic action to improve academic and administrative activities. The cell imparts mechanisms and procedures for ensuring the timely, efficient and progressive performance of academic, administrative and financial tasks. It also focuses on optimization and integration of modern methods of teaching, learning and evaluation and ensuring the adequacy, maintenance and functioning of the support services.',
    },
    aCalander1: {
      title: 'Academic Calender',
      aCalander1_data: [
        {
          id: 1,
          title: 'Almanacs',
          fileUrl: ['dbralc/IQAC/AboutIQAC/OU Almanacs.pdf'],
          disabled: false,
        },
      ],
    },

    // iqac: {
    //   title:
    //     "IQAC Meetings 2019",
    //   iqac_data: [
    //     {
    //       id: "7",
    //       title: "IQAC Meetings",
    //       fileUrl: [
    //         "dbralc/IQAC/AboutIQAC/iqac 2019 (1).pdf"
    //       ],
    //     }
    //   ],
    // }
  }

  const handleViewPDF = (doc) => {
    navigate(`/aboutIQAC/${doc.id}/${doc.title}`, { state: { doc } })
  }

  return (
    <section className="container py-4">
      <Typography variant="h6" component="div" sx={{ my: 2 }}>
        {About_IQAC_data.ABOUT.title}
      </Typography>
      <Typography variant="p" component="div" sx={{ my: 2 }}>
        {About_IQAC_data.ABOUT.description}
      </Typography>
      {Object.keys(About_IQAC_data)
        .filter((key) => key !== 'ABOUT')
        .map((key) => {
          const section = About_IQAC_data[key]
          const dataKey = Object.keys(section).find((k) => k.endsWith('_data'))

          if (!dataKey) {
            return null
          }

          const data = section[dataKey]

          return (
            <div className="my-4" key={key}>
              <div>
                <h6>{section.title}</h6>
              </div>
              {data.map((item, index) => (
                <div key={index}>
                  <small
                    className={`text-decoration ${
                      item.disabled ? 'disabled' : 'custom-cursor-pointer'
                    }`}
                    onClick={() => handleViewPDF(item)}
                    disabled={item.disabled}
                  >
                    {item.title}
                  </small>
                </div>
              ))}
            </div>
          )
        })}
    </section>
  )
}

export default AboutIQAC
